<section class="cmn-innerpage-wrapper">
  <div class="inner-content dashboard" *ngIf="!contentLoading">
    <div class="head">
      <h1>{{ challangeId ? "Edit Challenge" : "Add New Challenge" }}</h1>
    </div>
    <div class="challengeLangWrapper">
      <form id="translation" [formGroup]="mainForm">
        <div class="challengeFormWrapper">
          <label class="image-wrapper-label block-pointer">
            <span>Upload Image</span>
            <div class="borderedWrapper">
              <div class="fileSection">
                <label for="imageFile" class="unblock-pointer">
                  Choose A File
                  <input
                    type="file"
                    id="imageFile"
                    #imagefileInput
                    (change)="onImageUpload($event)"
                    accept=".jpeg, .jpg, .png, .webp"
                    formControlName="imageURL"
                  />
                </label>
                <div class="uploadedFiles" *ngIf="imageFileName">
                  <ul>
                    <li>
                      <h6>{{ imageFileName }}</h6>
                      <img
                        src="../../../assets/images/icons/icon-close.svg"
                        alt="Remove"
                        class="unblock-pointer"
                        style="cursor: pointer"
                        (click)="clearImageUpload()"
                      />
                    </li>
                  </ul>
                </div>
              </div>
              <h6>
                Image should be in JPG, JPEG or PNG format and not exceed 15MB
                in size.
              </h6>
            </div>
          </label>
        </div>
        <div class="challengeFormWrapper">
          <label class="width-Wrapper">
            <mat-form-field appearance="fill">
              <mat-select formControlName="langId" placeholder="Language">
                <mat-option
                  *ngFor="let lang of languages"
                  [value]="lang.id"
                  [disabled]="isLangUsed(lang.id)"
                >
                  {{ lang.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="mainForm.get('langId')?.hasError('required')"
                >Language is required</mat-error
              >
            </mat-form-field>
          </label>
          <label class="full-width-wrapper block-pointer">
            <mat-form-field>
              <input
                type="text"
                matInput
                placeholder="Challenge name"
                formControlName="challengeName"
                maxlength="51"
              />
              <mat-error
                *ngIf="mainForm.get('challengeName')?.hasError('required')"
                >Challenge name is required</mat-error
              >
              <mat-error
                *ngIf="mainForm.get('challengeName')?.hasError('maxlength')"
                >Challenge name cannot exceed 50 characters</mat-error
              >
              <mat-error
                *ngIf="mainForm.get('challengeName')?.hasError('onlySpaces')"
                >Challenge name cannot be empty</mat-error
              >
              <mat-error
                *ngIf="
                  mainForm
                    .get('challengeName')
                    ?.hasError('onlySpecialAlphaChars')
                "
                >Challenge name cannot contain only special chacaters and
                numbers</mat-error
              >
            </mat-form-field>
          </label>
        </div>
        <div
          class="btn-wrapper-div"
          *ngIf="challengeTranslations.length !== languages.length"
        >
          <p>Add at least one translation to save</p>
          <button type="button" (click)="addChallengeTable()" class="add-button  unblock-pointer">
            Add
          </button>
        </div>
      </form>
      <div *ngIf="!challangeId" class="checkbox-div block-pointer">
        <label class="checkbox-label">
          <input
            type="checkbox"
            class="styled-checkbox unblock-pointer"
            [(ngModel)]="isCustomChallenge"
          />
          <p>Create as custom challenge</p>
        </label>
      </div>
    </div>
    <div *ngIf="challengeTranslations?.length" class="tableWrapper">
      <table>
        <thead>
          <tr>
            <th>No</th>
            <th>Language</th>
            <th>Challenge name</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="let challenge of challengeTranslations; let i = index"
          >
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ getLanguageName(challenge.langId) }}</td>
              <td class="content-row">{{ challenge.challengeName }}</td>
              <td>
                <div class="actionWrapper">
                  <div
                    *ngIf="challenge.langId !== 1"
                    class="actionItem"
                    (click)="removeChallengeTranslation(i, challenge.id)"
                  >
                    <img
                      src="../../../assets/images/icons/icon-delete.svg"
                      alt=""
                    />
                  </div>
                  <div class="actionItem" (click)="editChallengeTranslation(i)">
                    <img
                      src="../../../assets/images/icons/icon-edit.svg"
                      alt=""
                    />
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="btnWrapper">
      <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
      <button
        [disabled]="!challengeTranslations.length || isSubmitting"
        class="cmn-next-btn"
        (click)="createChallenge()"
      >
        {{ challangeId ? "Update" : "Save" }}
      </button>
    </div>
  </div>
  <app-content-loader [visible]="contentLoading"></app-content-loader>
</section>

<app-fullscreen-loader
  [visible]="imageUploading || loading"
  [message]="
    imageUploading ? 'Uploading file, please wait...' : 'Saving, Please wait'
  "
>
</app-fullscreen-loader>
